import { createAction, props } from '@ngrx/store';

export const AUTH_SET_EMAIL = '[AUTH][SET]::[Email]';
export const AUTH_SET_VERIFIED = '[AUTH][SET]::[Verified]';
export const AUTH_SET_TOKEN = '[AUTH][SET]::[Token]';
export const AUTH_RESET_ALL = '[AUTH][RESET]::[All]';

export const SetEmail = createAction(
  AUTH_SET_EMAIL,
  props<{ email: string }>()
);
export const SetVerified = createAction(
  AUTH_SET_VERIFIED,
  props<{ verified: boolean }>()
);
export const SetToken = createAction(
  AUTH_SET_TOKEN,
  props<{ token: string }>()
);
export const ResetAll = createAction(AUTH_RESET_ALL);
